export default __webpack_public_path__ + "dc09ced5bd1b256daa16a8c65fe5e5da.jpg";